import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ZillowHomeLogo } from '@zillow/app-upsell-utils';
import { Card, CardHeader, Heading, Button, CardSection, Flex, ZillowHomeLogo as ZillowHomeLogo$1 } from '@zillow/constellation';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _jsxFileName$3 = "/builds/zillow/app-acquisition/app-upsell-two-cta/src/components/TwoCta.js",
    _templateObject$3;
var StyledContainer = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    z-index: 1100;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    background: #FFF;\n\n    &.hidden {\n        display: none;\n    }\n"])));

var TwoCta = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TwoCta, _React$Component);

  function TwoCta() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TwoCta.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        hidden = _this$props.hidden;
    return /*#__PURE__*/React.createElement(StyledContainer, {
      className: hidden ? 'hidden' : '',
      __self: this,
      __source: {
        fileName: _jsxFileName$3,
        lineNumber: 22,
        columnNumber: 13
      }
    }, children);
  };

  return TwoCta;
}(React.Component);

TwoCta.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  hidden: PropTypes.bool
} : {};
TwoCta.defaultProps = {
  hidden: false
};

var _jsxFileName$2 = "/builds/zillow/app-acquisition/app-upsell-two-cta/src/components/BrowserSelectNoConstellation.js",
    _templateObject$2,
    _templateObject2$2,
    _templateObject3$2,
    _templateObject4$2,
    _templateObject5$2,
    _templateObject6$2,
    _templateObject7$2,
    _templateObject8$1,
    _templateObject9$1,
    _templateObject10$1,
    _this$2 = undefined;
var StyledText$1 = css(["font-family:\"Open Sans\",Tahoma,Geneva,sans-serif;letter-spacing:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"]);
var StyledCard$2 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n    padding: 16px 24px;\n    border-top-left-radius: 25px;\n    border-top-right-radius: 25px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);\n    border-width: 0;\n"])));
var StyledHeader$1 = styled.h5(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n    ", "\n    text-align: center;\n    padding-bottom: 14px;\n    margin-top: 0;\n    margin-bottom: 13px;\n    border-bottom: 1px solid #F1F1F4;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n"])), StyledText$1);
var StyledLogoContainer$1 = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: 48px;\n    height: 48px;\n    padding: 5px;\n    border: 1px solid #f1f1f4;\n    border-radius: 3px;\n"])));
var StyledZillowHomeLogoBackground$1 = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: 36px;\n    height: 36px;\n    padding: 7px 8px 8px 8px;\n    border-radius: 3px;\n    background: #006AFF;\n"])));
var StyledCopy$1 = styled.p(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n    ", "\n    padding-left: 8px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0;\n"])), StyledText$1);
var StyledButton$1 = styled.button(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n    ", "\n    width: 115px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    height: 36px;\n    padding: 5px 20px;\n    margin: 0;\n    display: inline-block;\n    box-sizing: border-box;\n    border: 1px solid #006AFF;\n    border-radius: 3px;\n    user-select: none;\n    color: #FFF;\n    background-color: #006AFF;\n"])), StyledText$1);
var StyledSecondaryButton = styled(StyledButton$1)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n    background-color: #F9F9FB;\n    color: #006AFF;\n"])));
var FlexContainer = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
var FlexColumn = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center\n"])));
var FlexItem$1 = styled.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n"])));

var BrowserSelectContent$1 = function BrowserSelectContent(props) {
  var dismissed = props.dismissed,
      adjustTracker = props.adjustTracker,
      webLogo = props.webLogo,
      webCopy = props.webCopy,
      dismissUpsell = props.dismissUpsell,
      navigateToAdjust = props.navigateToAdjust;
  return /*#__PURE__*/React.createElement(TwoCta, {
    hidden: dismissed,
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 113,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledCard$2, {
    cardType: "secondary",
    cardElevation: 0,
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 114,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledHeader$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 115,
      columnNumber: 13
    }
  }, "See Zillow In..."), /*#__PURE__*/React.createElement("section", {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 116,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FlexContainer, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 117,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(FlexColumn, {
    style: {
      'marginBottom': '8px'
    },
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 118,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FlexItem$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 119,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledLogoContainer$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 120,
      columnNumber: 29
    }
  }, /*#__PURE__*/React.createElement(StyledZillowHomeLogoBackground$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 121,
      columnNumber: 33
    }
  }, /*#__PURE__*/React.createElement(ZillowHomeLogo, {
    style: {
      height: '21px'
    },
    fontColor: "white",
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 122,
      columnNumber: 37
    }
  }))), /*#__PURE__*/React.createElement(StyledCopy$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 125,
      columnNumber: 29
    }
  }, "Zillow app")), /*#__PURE__*/React.createElement(StyledButton$1, {
    onClick: navigateToAdjust,
    "data-tracker": adjustTracker,
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 127,
      columnNumber: 25
    }
  }, "Open app")), /*#__PURE__*/React.createElement(FlexColumn, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 129,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FlexItem$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 130,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledLogoContainer$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 131,
      columnNumber: 29
    }
  }, webLogo), /*#__PURE__*/React.createElement(StyledCopy$1, {
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 134,
      columnNumber: 29
    }
  }, webCopy)), /*#__PURE__*/React.createElement(StyledSecondaryButton, {
    onClick: dismissUpsell,
    __self: _this$2,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 136,
      columnNumber: 25
    }
  }, "Continue"))))));
};

BrowserSelectContent$1.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissed: PropTypes.bool,
  adjustTracker: PropTypes.string.isRequired,
  webLogo: PropTypes.object,
  webCopy: PropTypes.string,
  dismissUpsell: PropTypes.func,
  navigateToAdjust: PropTypes.func
} : {};

var _jsxFileName$1 = "/builds/zillow/app-acquisition/app-upsell-two-cta/src/components/BrowserSelectContent.js",
    _templateObject$1,
    _templateObject2$1,
    _templateObject3$1,
    _templateObject4$1,
    _templateObject5$1,
    _templateObject6$1,
    _templateObject7$1,
    _this$1 = undefined;
var StyledCard$1 = styled(Card)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n    padding: 16px 24px;\n    border-top-left-radius: 25px;\n    border-top-right-radius: 25px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);\n    border-width: 0;\n"])));
var StyledHeader = styled(CardHeader)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    padding-bottom: 14px;\n    margin-bottom: 13px;\n    border-color: #F1F1F4\n"])));
var StyledLogoContainer = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: 48px;\n    height: 48px;\n    padding: 5px;\n    border: 1px solid #f1f1f4;\n    border-radius: 3px;\n"])));
var StyledZillowHomeLogoBackground = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: 36px;\n    height: 36px;\n    padding: 7px 8px 8px 8px;\n    border-radius: 3px;\n    background: #006AFF;\n"])));
var StyledCopy = styled(Heading)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n    padding-left: 8px;\n"])));
var StyledButton = styled(Button)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n    width: 115px;\n"])));
styled(StyledButton)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n    background-color: #F9F9FB;\n    border-color: #006AFF;\n"])));

var BrowserSelectContent = function BrowserSelectContent(props) {
  var dismissed = props.dismissed,
      adjustTracker = props.adjustTracker,
      webLogo = props.webLogo,
      webCopy = props.webCopy,
      dismissUpsell = props.dismissUpsell,
      navigateToAdjust = props.navigateToAdjust;
  return /*#__PURE__*/React.createElement(TwoCta, {
    hidden: dismissed,
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 73,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledCard$1, {
    cardType: "secondary",
    cardElevation: 0,
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 74,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledHeader, {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 75,
      columnNumber: 13
    }
  }, "See Zillow In..."), /*#__PURE__*/React.createElement(CardSection, {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 76,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 77,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "xs",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 78,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 79,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledLogoContainer, {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 80,
      columnNumber: 29
    }
  }, /*#__PURE__*/React.createElement(StyledZillowHomeLogoBackground, {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 81,
      columnNumber: 33
    }
  }, /*#__PURE__*/React.createElement(ZillowHomeLogo$1, {
    removeTrademark: true,
    style: {
      height: '21px'
    },
    fontColor: "white",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 82,
      columnNumber: 37
    }
  }))), /*#__PURE__*/React.createElement(StyledCopy, {
    level: "6",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 85,
      columnNumber: 29
    }
  }, "Zillow app")), /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "primary",
    size: "sm",
    onClick: navigateToAdjust,
    "data-tracker": adjustTracker,
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 87,
      columnNumber: 25
    }
  }, "Open app")), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 89,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 90,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledLogoContainer, {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 91,
      columnNumber: 29
    }
  }, webLogo), /*#__PURE__*/React.createElement(StyledCopy, {
    level: "6",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 94,
      columnNumber: 29
    }
  }, webCopy)), /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "tertiary",
    size: "sm",
    onClick: dismissUpsell,
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 96,
      columnNumber: 25
    }
  }, "Continue"))))));
};

BrowserSelectContent.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissed: PropTypes.bool,
  adjustTracker: PropTypes.string.isRequired,
  webLogo: PropTypes.object,
  webCopy: PropTypes.string,
  dismissUpsell: PropTypes.func,
  navigateToAdjust: PropTypes.func
} : {};

var _jsxFileName = "/builds/zillow/app-acquisition/app-upsell-two-cta/src/components/StackedCTANoConstellation.js",
    _templateObject,
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7,
    _templateObject8,
    _templateObject9,
    _templateObject10,
    _this = undefined;
var StyledText = css(["font-family:\"Open Sans\",Tahoma,Geneva,sans-serif;letter-spacing:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"]);
var StyledCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: 16px 24px 10px 24px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);\n    border-width: 0;\n"])));
var StyledLogoTab = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    height: 11px;\n"])));
var LogoTab = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    background: white;\n    border-radius: 50%;\n    width: 56px;\n    height: 56px;\n    transform: translateY(-45px);\n    box-shadow: 0px -1px 0px rgba(0,0,0,0.1)\n"])));
var StyledHeading = styled.h6(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    ", "\n    margin: 0;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n"])), StyledText);
var StyledZillowHomeLogo = styled(ZillowHomeLogo)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    transform: translateY(10px);\n"])));
var StyledPrimaryButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    ", "\n    width: 100%;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 24px;\n    height: 36px;\n    text-decoration: none;\n    margin: 0;\n    display: inline-block;\n    box-sizing: border-box;\n    border: 1px solid #006AFF;\n    border-radius: 3px;\n    user-select: none;\n    color: #FFF;\n    background-color: #006AFF;\n"])), StyledText);
var StyledTextButton = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    ", "\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    width: 100%;\n    border: 0;\n    margin: 0;\n    padding: 0;\n    color: #006AFF;\n    background: transparent;\n"])), StyledText);
var FlexHeader = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n"])));
var FlexRow = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n"])));
var FlexItem = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n"])));

var StackedCTAContent = function StackedCTAContent(props) {
  var dismissed = props.dismissed,
      adjustTracker = props.adjustTracker,
      dismissUpsell = props.dismissUpsell,
      navigateToAdjust = props.navigateToAdjust;
  return /*#__PURE__*/React.createElement(TwoCta, {
    hidden: dismissed,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledCard, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FlexHeader, {
    display: "flex",
    justifyContent: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(StyledLogoTab, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(LogoTab, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledZillowHomeLogo, {
    style: {
      height: '35px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 29
    }
  })))), /*#__PURE__*/React.createElement("section", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(FlexRow, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FlexItem, {
    style: {
      'marginBottom': '16px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 29
    }
  }, "Zillow, and then some...")), /*#__PURE__*/React.createElement(FlexItem, {
    style: {
      'marginBottom': '8px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledPrimaryButton, {
    onClick: navigateToAdjust,
    "data-tracker": adjustTracker,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 29
    }
  }, "Open app")), /*#__PURE__*/React.createElement(FlexItem, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(StyledTextButton, {
    onClick: dismissUpsell,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 29
    }
  }, "Not now"))))));
};

StackedCTAContent.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissed: PropTypes.bool,
  adjustTracker: PropTypes.string.isRequired,
  dismissUpsell: PropTypes.func,
  navigateToAdjust: PropTypes.func
} : {};

export { BrowserSelectContent as BrowserSelect, BrowserSelectContent$1 as BrowserSelectNoConstellation, StackedCTAContent as StackedCTANoConstellation };
